import React, { useState, useRef } from "react";
import { IoCloudUploadOutline, IoTrashOutline } from "react-icons/io5";
import {
  Box, InputAdornment, Grid,
  Avatar,
  Typography,
  MobileStepper,
  TextField,
  Select,
  MenuItem,
  IconButton,
  iconList,
  Button,
} from "@mui/material";
import ProjectHeaderLogo from "assets/images/Group 1171275838.svg";
import ProjectImage from "assets/images/NotebookImage.svg";
import { FaRegCalendarAlt } from "react-icons/fa";


const FourthStep = ({ formik, handleClick, handlePrevious, activeStep, steps }) => {


  const phoneCodes = ["+91", "+1", "+44", "+61", "+81", "+49", "+33", "+39", "+86", "+971"];
  const fileInputRef = useRef(null);

  const handleIconClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      formik.setFieldValue("project_image", file);
    }
  };

  const handleRemove = () => {
    formik.setFieldValue("project_image", null);
  };




  return (
    <>
      <Box
        sx={{
          backgroundColor: "#f3f3f3",
          minHeight: "100vh",
          p: { xs: "24px 16px", sm: "40px 24px", md: "80px 0px 0px 132px" },
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "flex-end" },
            gap: { xs: 5, sm: 6, md: 8, lg: "326px" },
            width: "100%",
            maxWidth: "100%",
            p: { xs: 0, sm: 0, md: "7px 132px 21px 0px" },
            boxSizing: "border-box",
          }}
        >
          {/* Left Section */}
          <Box
            sx={{
              flex: 1,
              width: { xs: "100%", sm: "100%", md: "525px" },
              maxWidth: "525px",
              display: "flex",
              flexDirection: "column",
              boxSizing: "border-box",

            }}
          >
            {/* Logo */}
            <Avatar
              src={ProjectHeaderLogo}
              sx={{
                width: { xs: 50, sm: 60, md: 60 },
                height: { xs: 50, sm: 60, md: 60 },
                bgcolor: "transparent",
                "& img": {
                  objectFit: "contain",
                  width: "100%",
                  height: "100%",
                },
              }}
            />
            <Box sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: "13px",
              width: "100%",
            }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", alignItems: "flex-start", width: "100%", p: 0 }}>
                <Typography
                  sx={{
                    mt: "0px",
                    fontWeight: 700,
                    fontSize: { xs: "28px", sm: "32px", md: "36px" },
                    lineHeight: 1.1,
                    fontFamily: "Outfit, sans-serif",
                    color: "#252C32",
                  }}
                >
                  Contact Info
                </Typography>

                {/* Stepper */}
                <MobileStepper
                  variant="progress"
                  steps={steps}
                  position="relative"
                  activeStep={activeStep}
                  sx={{
                    width: { xs: "110%", sm: "110%", md: "105%" },
                    mt: 0,
                    p: 0,
                    background: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    "& .MuiMobileStepper-progress": {
                      flexGrow: 1,
                      width: "100%",
                    },
                    "& .MuiLinearProgress-root": {
                      width: "100%",
                      backgroundColor: "#E9E9E9",
                      height: 4,
                      borderRadius: "4px",
                    },
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#143DF2",
                    },
                  }}
                />

              </Box>
              <Typography sx={{
                fontSize: "18px",
                fontWeight: 500,
                color: "#9B9C9F",
                letterSpacing: "0px",
                fontFamily: "Outfit"
              }}>
                4/4
              </Typography>
            </Box>

            {/* Description Texts */}
            <Box
              sx={{
                mt: "15px",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: 1.3,
                  fontFamily: "Outfit, sans-serif",
                  color: "#5B5772",
                }}
              >
                Explore what’s possible when you collaborate with your team. Edit
                project details anytime in project settings.
              </Typography>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: 1.3,
                  fontFamily: "Outfit, sans-serif",
                  color: "#5B5772",
                }}
              >
                Required fields are marked with an asterisk{" "}
                <Box component="span" sx={{ color: "#D92D20" }}>
                  *
                </Box>
              </Typography>
            </Box>

            {/* Form Fields */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", mt: "30px" }}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "16px",
                    fontFamily: "Outfit, sans-serif",
                    color: "#5F5F5F",
                  }}
                >
                  Project Admin{" "}
                  <Box component="span" sx={{ color: "#D92D20" }}>
                    *
                  </Box>
                </Typography>
                <TextField
                  placeholder="Project Admin"
                  fullWidth
                  variant="standard"
                  InputProps={{
                    disableUnderline: true,
                  }}
                  sx={{
                    mt: "9px",
                    "& .MuiInput-root": {
                      borderRadius: "8px",
                      backgroundColor: "#FFFFFF",
                      height: 48,
                      px: 2,
                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiInput-input": {
                      fontFamily: "Outfit, sans-serif",
                      padding: 0,
                      color: "#0A0A0C",
                      "&:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                        WebkitTextFillColor: "#0A0A0C !important",
                        borderRadius: "8px",
                      },
                      "&:-webkit-autofill:hover": {
                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                      },
                      "&:-webkit-autofill:focus": {
                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                      },
                    },
                  }}
                  name="project_manager_name"
                  value={formik.values.project_manager_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.project_manager_name && Boolean(formik.errors.project_manager_name)}
                  helperText={formik.touched.project_manager_name && formik.errors.project_manager_name}
                />

              </Box>
            </Box>

            {/* Project Type */}
            <Box sx={{ mt: "15px" }}>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "16px",
                  fontFamily: "Outfit, sans-serif",
                  color: "#5F5F5F",
                }}
              >
                Designation{" "}
                <Box component="span" sx={{ color: "#D92D20" }}>
                  *
                </Box>
                <Grid container rowSpacing={1.4} columnSpacing={1}>
                  <Grid size={12}>
                    <TextField
                      placeholder="Designation"
                      fullWidth
                      variant="standard"
                      InputProps={{
                        disableUnderline: true,
                      }}
                      sx={{
                        mt: "9px",
                        "& .MuiInput-root": {
                          borderRadius: "8px",
                          backgroundColor: "#FFFFFF",
                          height: 48,
                          px: 2,
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiInput-input": {
                          fontFamily: "Outfit, sans-serif",
                          padding: 0,
                          color: "#0A0A0C",
                          "&:-webkit-autofill": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                            WebkitTextFillColor: "#0A0A0C !important",
                            borderRadius: "8px",
                          },
                          "&:-webkit-autofill:hover": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                          },
                          "&:-webkit-autofill:focus": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                          },
                        },
                      }}
                      name="project_manager_designation"
                      value={formik.values.project_manager_designation}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.project_manager_designation && Boolean(formik.errors.project_manager_designation)}
                      helperText={formik.touched.project_manager_designation && formik.errors.project_manager_designation}
                    />

                  </Grid>

                </Grid>

              </Typography>

            </Box>
            <Box sx={{ mt: "15px" }}>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "16px",
                  fontFamily: "Outfit, sans-serif",
                  color: "#5F5F5F",
                }}
              >
                Work Email {" "}
                <Box component="span" sx={{ color: "#D92D20" }}>
                  *
                </Box>
              </Typography>
              <Grid size={12}>
                <TextField
                  placeholder="abc@gmail.com"
                  fullWidth
                  variant="standard"
                  InputProps={{
                    disableUnderline: true,
                  }}
                  sx={{
                    mt: "9px",
                    "& .MuiInput-root": {
                      borderRadius: "8px",
                      backgroundColor: "#FFFFFF",
                      height: 48,
                      px: 2,
                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiInput-input": {
                      fontFamily: "Outfit, sans-serif",
                      padding: 0,
                      color: "#0A0A0C",
                      "&:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                        WebkitTextFillColor: "#0A0A0C !important",
                        borderRadius: "8px",
                      },
                      "&:-webkit-autofill:hover": {
                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                      },
                      "&:-webkit-autofill:focus": {
                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                      },
                    },
                  }}
                  name="project_manager_email"
                  value={formik.values.project_manager_email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.project_manager_email && Boolean(formik.errors.project_manager_email)}
                  helperText={formik.touched.project_manager_email && formik.errors.project_manager_email}
                />
              </Grid>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", mt: "15px" }}>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "16px",
                  fontFamily: "Outfit, sans-serif",
                  color: "#5F5F5F",
                }}
              >
                Phone number{" "}
                <Box component="span" sx={{ color: "#D92D20" }}>
                  *
                </Box>
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  height: "48px",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "8px",
                  px: "8px",
                  boxSizing: "border-box",
                  overflow: "hidden"
                }}
              >
                {/* Left Side - Currency Dropdown */}
                <TextField
                  select
                  variant="standard"
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    width: "55px",
                    "& .MuiSelect-select": {
                      p: 0,
                      fontSize: "16px",
                      fontWeight: 400,
                      color: "#0A0A0C",
                      display: "flex",
                      alignItems: "center",
                      fontFamily: "Outfit, sans-serif"
                    },
                  }}
                  name="country_code"
                  value={formik.values.country_code}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.country_code && Boolean(formik.errors.country_code)}
                  helperText={formik.touched.country_code && formik.errors.country_code}
                >{
                    phoneCodes.map((item, ind) => (
                      <MenuItem key={ind} value={item}>
                        {item}
                      </MenuItem>

                    ))
                  }
                </TextField>

                {/* Divider line between dropdown and textfield */}
                <Box
                  sx={{
                    width: "1px",
                    height: "60%",
                    backgroundColor: "#C8C8C8",
                  }}
                />

                {/* Right Side - Text Input */}
                <TextField
                  placeholder="Phone Number"
                  variant="standard"
                  InputProps={{
                    disableUnderline: true,
                  }}
                  sx={{
                    flex: 1,
                    ml: "8px",
                    "& input": {
                      fontSize: "16px",
                      fontWeight: 400,
                      color: "#0A0A0C",
                      p: 0,
                      fontFamily: "Outfit, sans-serif",
                      "&:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                        WebkitTextFillColor: "#0A0A0C !important",
                        borderRadius: "8px",
                      },
                      "&:-webkit-autofill:hover": {
                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                      },
                      "&:-webkit-autofill:focus": {
                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                      },
                    },
                    "& input::placeholder": {
                      color: "#8C8C8C",
                      fontFamily: "Outfit, sans-serif"
                    },
                  }}
                  name="project_manager_phoneno"
                  value={formik.values.project_manager_phoneno}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.project_manager_phoneno && Boolean(formik.errors.project_manager_phoneno)}
                />
              </Box>
              {formik.touched.project_manager_phoneno && formik.errors.project_manager_phoneno && (
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#d32f2f",
                    fontFamily: "Outfit",
                  }}
                >
                  {formik.errors.project_manager_phoneno}
                </Typography>
              )}

            </Box>
            <Box sx={{ mt: "15px" }}>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "16px",
                  fontFamily: "Outfit, sans-serif",
                  color: "#5F5F5F",
                }}
              >
                Upload Image{" "}
                <Box component="span" sx={{ color: "#D92D20" }}>
                  *
                </Box>
              </Typography>

              <Box
                sx={{
                  mt: "8px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "3px",
                  width: 80,
                  height: 40,
                  cursor: "pointer",
                  transition: "0.2s",
                  "&:hover": { borderColor: "#6B6B6B", backgroundColor: "#FAFAFA" },
                }}
                onClick={handleIconClick}
              >
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />

                <IoCloudUploadOutline size={20} color="#6B6B6B" />
              </Box>

              {formik.values.project_image && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    mt: 0,
                    gap: 1,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#0A0A0C",
                      fontFamily: "Outfit, sans-serif",
                      width: "auto",
                      // maxWidth: "120px",
                      // overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {formik.values.project_image.name}
                  </Typography>

                  <IconButton
                    size="small"
                    onClick={handleRemove}
                    sx={{
                      color: "#D92D20",
                      "&:hover": { backgroundColor: "transparent" },
                    }}
                  >
                    <IoTrashOutline size={16} />
                  </IconButton>
                </Box>
              )}
              {formik.touched.project_image && formik.errors.project_image && (
                <Typography
                  sx={{
                    fontFamily: "Outfit, sans-serif",
                    fontSize: "12px",
                    color: "#D92D20",
                    mt: "4px",
                    textAlign: "center",
                  }}
                >
                  {formik.errors.project_image}
                </Typography>
              )}
            </Box>

            <Box sx={{
              mt: "20px",
              display: "flex",
              alignItems: "center",
              gap: "40px"
            }}>

              <Box sx={{
                width: "230px",
                height: "48px",
                borderRadius: "3px",
                backgroundColor: "#00344C",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
                <Button
                  type="button"
                  onClick={handleClick}
                  sx={{
                    fontWeight: 500,
                    fontSize: "16px",
                    lineHeight: "16px",
                    letterSpacing: "1%",
                    color: "#FFFFFF",
                    width: "100%",
                    height: "100%",
                    textTransform: "none",
                    fontFamily: "Outfit, sans-serif"
                  }}>
                  Save Project
                </Button>
              </Box>
              <Button
                onClick={handlePrevious}
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "12px",
                  color: "#143DF2",
                  textTransform: "none",
                  letterSpacing: "0%",
                  textDecoration: "underline",
                  p: 0,
                  minWidth: "auto",
                  fontFamily: "Outfit, sans-serif"
                }}
              >
                Previous step
              </Button>
            </Box>

          </Box>

          {/* Right Section (Image) */}
          <Box
            sx={{
              flexShrink: 0,
              width: { xs: "90%", md: "240px", lg: "327px" },
              height: { xs: "250px", md: "270px", lg: "350px" },
              border: "1px solid #ECECEC",
              borderRadius: "3px",
              bgcolor: "#FFFFFF",
              display: "flex",
              flexDirection: "column",
              mt: { xs: 4, md: 0 },
              p: "30px",
              alignSelf: { xs: "center", md: "center" },
            }}
          >
            <Box sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",

            }}>
              <Box
                component="img"
                src={ProjectImage}
                alt="Project preview"
                sx={{
                  width: { sm: "200px", md: "238px" },
                  height: "200",
                  objectFit: "contain",
                }}
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", mt: "18px", gap: "16px" }}>
              <Typography sx={{ fontSize: "16px", fontWeight: "600", lineHeight: "100%", color: "#3F3F3F", fontFamily: "Outfit, sans-serif" }}>
                Manage EPC Project
              </Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "100%", color: "#3F3F3F", fontFamily: "Outfit, sans-serif" }}>
                Manage design projects effectively, visualize tasks, and see team workload
              </Typography>
            </Box>

          </Box>
        </Box>
      </Box>
    </>
  );
};

export default FourthStep;
